import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import {  isTechnicalSupervisor } from '../Authetication'



export default function TechSupervisorRoutes() {


  let auth = {"token": isTechnicalSupervisor()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
